import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogActions, MatDialogContent, MatDialogModule, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { CommonFunctionsService } from '../../../../services/common-functions.service';

@Component({
    selector: 'app-unauthorized-access-dialog',
    standalone: true,
    templateUrl: './unauthorized-access-dialog.component.html',
    styleUrl: './unauthorized-access-dialog.component.scss',
    imports: [CommonModule, TranslatePipe, MatDialogModule, MatButtonModule, MatDialogActions, MatDialogTitle, MatDialogContent]
})
export class UnauthorizedAccessDialogComponent {
    constructor(
        private readonly dialogRef: MatDialogRef<UnauthorizedAccessDialogComponent>,
        private readonly commonFunctionsService: CommonFunctionsService
    ) { }

    onLogoutClick(): void {
        this.dialogRef.close();
        void this.commonFunctionsService.logout();
    }
}
